import { DEFAULT_ERROR_MESSAGE } from "@common/utils/use-query/constants";
import { IDataFetcherResponseError } from "@common/utils/use-query/types";
import { isValidElement, ReactNode } from "react";
import { FieldError } from "react-hook-form";

export function getContent(
  error: IDataFetcherResponseError | FieldError | Error | ReactNode,
): ReactNode {
  if (error) {
    if (
      typeof error === "string" ||
      typeof error === "number" ||
      isValidElement(error)
    ) {
      return error;
    }

    // Only keep arrays of renderable nodes (skip nested RHF error objects)
    if (Array.isArray(error)) {
      const content = error
        .map((item) => getContent(item))
        .filter((item) => item != null);
      return content.length > 0 ? content : null;
    }

    if (typeof error === "object") {
      // IDataFetcherResponseError
      if ("status" in error && typeof error.status === "number") {
        return getContent(
          error.message || `${DEFAULT_ERROR_MESSAGE}: ${error.status}`,
        );
      }

      // empty message fallback
      if (error instanceof Error) {
        return getContent(error.message || DEFAULT_ERROR_MESSAGE);
      }

      // FieldError
      if ("message" in error && typeof error.message === "string") {
        return getContent(error.message);
      }
    }
  }

  return null;
}
